module.exports = __webpack_public_path__ + "static/img/report_bg3.40c8cc10.png";